export default __webpack_public_path__ + "static/media/circle_2.84e22306.png";